import { IGroupMembersEvent } from '@wix/social-groups-serverless/dist/events/types';
import * as events from '@wix/social-groups-serverless/dist/events/http';
import {
  createGroupMembersEvent,
  deleteGroupMembersEvent,
} from '@wix/ambassador-socialgroups-v1-group-members-event/http';

import * as application from 'store/application';

import { createAsyncThunk } from '../utils';

export const fetch = createAsyncThunk(
  'events:fetch',
  async function (groupId: string, thunkAPI) {
    return thunkAPI.extra.httpClient
      .request(events.getConnectedEvents(groupId))
      .then((response) => response.data);
  },
);

export const create = createAsyncThunk(
  'events:create',
  async function (params: IGroupMembersEvent, thunkAPI) {
    const { data } = await thunkAPI.extra.httpClient.request(
      createGroupMembersEvent({
        event: {
          ...params,
          dateAndTimeSettings: {
            ...params.dateAndTimeSettings,
            startDate: new Date(params.dateAndTimeSettings.startDate),
            endDate: new Date(params.dateAndTimeSettings.endDate),
          },
        },
      }),
    );

    thunkAPI.dispatch(
      application.actions.showToast({
        type: 'success',
        i18nParams: { i18nKey: 'groups-web.toast.events.create' },
      }),
    );

    return data;
  },
  {
    formatError: (params) => ({
      i18nKey: 'groups-web.toast.error.events.create',
    }),
  },
);

export const update = createAsyncThunk(
  'events:update',
  async function (params: IGroupMembersEvent, thunkAPI) {
    const { data } = await thunkAPI.extra.httpClient.request(
      events.update({
        event: params,
      }),
    );

    thunkAPI.dispatch(
      application.actions.showToast({
        type: 'success',
        i18nParams: { i18nKey: 'groups-web.toast.events.update' },
      }),
    );

    return data;
  },
  {
    formatError: (params) => ({
      i18nKey: 'groups-web.toast.error.events.update',
    }),
  },
);

export const cancel = createAsyncThunk(
  'events:cancel',
  async function (eventId: string, thunkAPI) {
    const flowApi = thunkAPI.extra;
    const { data } = await flowApi.httpClient.request(
      deleteGroupMembersEvent({ eventId }),
    );

    thunkAPI.dispatch(
      application.actions.showToast({
        type: 'success',
        i18nParams: {
          i18nKey: 'groups-web.events.actions.cancel.success',
        },
      }),
    );

    return data;
  },
  {
    errorCodesMap: ({ translations: { t } }) => ({
      applicationError: {
        CANNOT_DELETE_NON_RSVP_EVENT: () => ({
          message: t('groups-web.toast.error.events.cancel.non-rsvp'),
        }),
      },
    }),
  },
);
